import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Auto-scrolls to top on every route change.
 * Also stores the last visited authenticated route so we can restore
 * users to where they were on next login (except transient/auth pages).
 */
const IGNORED_FOR_MEMORY = [
  "/login",
  "/registro",
  "/brujula",           // brújula entry is a transient decision flow
  "/brujula/pais",
  "/brujula/ciudad",
  "/brujula/idea",
  "/brujula/negocio",
  "/brujula/analizando",
];

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Always start new pages at the top.
    try { window.scrollTo({ top: 0, left: 0, behavior: "instant" }); }
    catch { window.scrollTo(0, 0); }

    // Remember last working location for smart entry on next login.
    // We deliberately never store '/' (Hoy) — that's the natural SmartEntry
    // landing and would defeat the purpose of returning users to their last
    // real working screen.
    const shouldRemember =
      pathname !== "/" &&
      !IGNORED_FOR_MEMORY.some((p) => pathname === p) &&
      !pathname.startsWith("/brujula/resultado"); // resultado is single-use
    if (shouldRemember) {
      try { localStorage.setItem("ruta_last_route", pathname); } catch {}
    }
  }, [pathname]);

  return null;
}
